export function getAuthHeader(){
    let token = sessionStorage.getItem('token');
    let authToken = "Token "+token;
    let authHeader = {headers: {
        Authorization: authToken
    }};
    return authHeader;
}